"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElementInViewport = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var useElementInViewport = exports.useElementInViewport = function useElementInViewport(_ref) {
  var elementRef = _ref.elementRef,
    containerElementSelector = _ref.containerElementSelector;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isElementInView = _useState2[0],
    setIsElementInView = _useState2[1];
  (0, _react.useEffect)(function () {
    var containerElement = null;
    var handleScroll = function handleScroll() {
      if (elementRef.current) {
        var rect = elementRef.current.getBoundingClientRect();
        var _inView = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        setIsElementInView(_inView);
      }
    };
    try {
      containerElement = document.querySelector(containerElementSelector);
      if (containerElement === null) {
        console.warn("Unable to get parent container element. Selector -: ".concat(containerElementSelector));
        // If for some reason, the container is not available, it should not fail
        setIsElementInView(true);
        return;
      }
      containerElement.addEventListener('scroll', handleScroll);
      handleScroll();
    } catch (e) {
      console.warn("Unable to get parent container element. Selector -: ".concat(containerElementSelector), e);
      // do nothing if the container is not available
      setIsElementInView(true);
      return;
    }
    return function () {
      if (containerElement !== null) {
        containerElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return isElementInView;
};